<template>
  <el-dialog :title="title" :visible.sync="isShow" :width="width" center @close='onCancel'>
    <div class="dialog-container">
      <slot name="dialog-page"></slot>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="onOk">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "ipo3-dialog",
  props:{
      title:{
        type:String,
        default:'对话框',
      },
      width:{
        type:String,
        default:'500px',
      },
      isShow:{
          type:Boolean,
          default:false,
      }
  },
  methods:{
    onOk(){
      this.$emit("ok");
    },
    onCancel()
    {
      this.$emit("cancel");
    }
  }
};
</script>

<style scoped lang='less'>
.dialog-container{
  min-height:100px;
  text-align: left;
}
</style>